import produce from "immer";
import {
  GET_ADMIN_LIST,
  GET_ADMIN_LIST_SUCCESS,
  GET_ADMIN_LIST_ERROR,
  ADD_ADMIN,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_ERROR,
  EDIT_ADMIN,
  EDIT_ADMIN_SUCCESS,
  EDIT_ADMIN_ERROR,
  DELETE_ADMIN,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_ERROR,
  SET_ADMIN_PAGE,
  SET_ADMIN_SORT_FIELD,
  SET_ADMIN_SORT_ORDER,
} from "./actionTypes";

const initialState = {
  adminList: [],
  loading: false,
  error: "",
  totalCount: 0,
  totalPages: 0,
  limit: 10,
  page: 1,
  count: 0,
  sortOrder: "desc",
  sortField: "firstName",
  search: "",
  addAdminLoad: false,
  editAdminLoad: false,
  deleteAdminLoad: false,
};

const adminsReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // Get Admin List
    case GET_ADMIN_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        adminList: payload?.data || [],
        totalCount: payload?.metadata?.totalCount || 0,
        totalPages: payload?.metadata?.totalPages || 0,
        limit: payload?.metadata?.limit,
        count: payload?.count || 0,
        loading: false,
        page: payload?.metadata?.page,
      };
    case GET_ADMIN_LIST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    // Add Admin
    case ADD_ADMIN:
      return {
        ...state,
        addAdminLoad: true,
      };
    case ADD_ADMIN_SUCCESS:
      return {
        ...state,
        addAdminLoad: false,
      };
    case ADD_ADMIN_ERROR:
      return {
        ...state,
        addAdminLoad: false,
      };

    // Edit Admin
    case EDIT_ADMIN:
      return {
        ...state,
        editAdminLoad: true,
      };
    case EDIT_ADMIN_SUCCESS:
      return {
        ...state,
        editAdminLoad: false,
      };
    case EDIT_ADMIN_ERROR:
      return {
        ...state,
        editAdminLoad: false,
      };

    // Delete Admin
    case DELETE_ADMIN:
      return {
        ...state,
        deleteAdminLoad: true,
      };
    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        deleteAdminLoad: false,
      };
    case DELETE_ADMIN_ERROR:
      return {
        ...state,
        deleteAdminLoad: false,
      };

    // Search and Pagination
    case SET_ADMIN_PAGE:
      return {
        ...state,
        page: payload,
      };
    case SET_ADMIN_SORT_FIELD:
      return {
        ...state,
        sortField: payload,
      };
    case SET_ADMIN_SORT_ORDER:
      return {
        ...state,
        sortOrder: payload,
      };

    default:
      return state;
  }
});

export default adminsReducer;

